export default "__VITE_ASSET__C99KcZ84__"